import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { EMPTY, Observable } from 'rxjs';
import { Router } from '@angular/router';

import { environment } from 'environments/environment';
import { AuthenticationService } from 'app/auth/service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  /**
   *
   * @param {AuthenticationService} _authenticationService
   */
  constructor(private _authenticationService: AuthenticationService, private _router: Router) {}

  /**
   * Add auth header with jwt if user is logged in and request is to api url
   * @param request
   * @param next
   */
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const currentUser = this._authenticationService.currentUserValue;
    const token = localStorage.getItem('b2b_token') || currentUser?.token;
    const isApiUrl = request.url.startsWith(environment.apiUrl) || request.url.startsWith('/api/');

    if (isApiUrl && token && this.isTokenExpired()) {
      this.clearSession();
      this._router.navigate(['/login']);
      return EMPTY;
    }

    if (token && isApiUrl) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    }

    return next.handle(request);
  }

  private isTokenExpired(): boolean {
    const exp = Number(localStorage.getItem('b2b_exp'));

    if (!exp) {
      return false;
    }

    return Math.floor(Date.now() / 1000) >= exp;
  }

  private clearSession(): void {
    localStorage.removeItem('b2b_token');
    localStorage.removeItem('b2b_user_data');
    localStorage.removeItem('b2b_username');
    localStorage.removeItem('b2b_exp');
    localStorage.removeItem('b2b_role');
  }
}
